<template>
  <div class="flex items-center gap-[4px] flex-wrap text-[#7C7379]">
    <div
      v-for="(crumb, index) in breadcrumbs"
      :key="index"
      class="flex items-center gap-[4px]"
    >
      <CaretDownIcon
        v-if="index > 0"
        class="min-w-[22px] h-[22px] p-[5px] rotate-270"
      />
      <router-link v-if="index < breadcrumbs.length - 1" :to="crumb.path">
        <span class="PC_Body2-R hover:underline">
          {{ crumb.label }}
        </span>
      </router-link>
      <span v-else class="PC_Body2-R ">
        {{ crumb.label }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getResolvedBreadcrumbs } from "../components/Utilities/javascripts/breadcrumb.js";

const route = useRoute();
const router = useRouter();

const breadcrumbs = computed(() => getResolvedBreadcrumbs(route, router));
</script>
